/* A simple point
 */
export class Point {
    x;
    y;
    constructor(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
}
/* A simple size
 */
export class Size extends Point {
}
